var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('img',{staticClass:"msp-logo-app",attrs:{"src":_vm.logoSrc,"alt":_vm.altText}})
}
var staticRenderFns = []

export { render, staticRenderFns }